export const lunchMenuDate = "15.10.2026";

const lunchSections = [
  {
    title: "Супи",
    title_en: "Soups",
    items: [
      {
        name: "Крем супа от моркови и картофи с чипс от моркови",
        name_en: "Cream of Carrot and Potato Soup with Carrot Crisps",
        desc: "",
        desc_en: "",
        weight: "300 г",
        weight_en: "300 g",
        price: "4.90 €",
        active: true,
      },
    ],
  },
  {
    title: "Салати",
    title_en: "Salads",
    items: [
      {
        name: "Салата Панцанела",
        name_en: "Panzanella Salad",
        desc: "",
        desc_en: "",
        weight: "200 г",
        weight_en: "200 g",
        price: "4.50 €",
        active: true,
      },
    ],
  },
  {
    title: "Паста",
    title_en: "Pasta",
    items: [
      {
        name: "Лазаня Болонезе",
        name_en: "Lasagna Bolognese",
        desc: "",
        desc_en: "",
        weight: "350 г",
        weight_en: "350 g",
        price: "10.90 €",
        active: true,
      },
    ],
  },
  {
    title: "Основни ястия",
    title_en: "Main Courses",
    items: [
      {
        name: "Мусака с кисело мляко",
        name_en: "Moussaka with Yogurt",
        desc: "",
        desc_en: "",
        weight: "350 г",
        weight_en: "350 g",
        price: "10.90 €",
        active: true,
      },
    ],
  },
  {
    title: "Десерти",
    title_en: "Desserts",
    items: [
      {
        name: "Шоколадов мус с орехи",
        name_en: "Chocolate Mousse with Walnuts",
        desc: "",
        desc_en: "",
        weight: "170 г",
        weight_en: "170 g",
        price: "4.90 €",
        active: true,
      },
    ],
  },
];

export default lunchSections;
